// Google Places API configuration
export const GOOGLE_MAPS_CONFIG = {
  AUTOCOMPLETE_API: "https://places.googleapis.com/v1/places:autocomplete",
  PLACE_DETAILS_API: "https://places.googleapis.com/v1/places",
  DEBOUNCE_DELAY_MS: 350,
  DEFAULT_ZOOM: 12,
  MARKER_ZOOM: 15,
} as const;

// Map default configuration
export const MAP_CONFIG = {
  DEFAULT_CENTER: {
    lat: 19.076,
    lng: 72.8777,
  },
  CONTAINER_HEIGHT: "280px",
  LIBRARIES: ["places"] as const,
} as const;

// Dropdown and suggestions configuration
export const DROPDOWN_CONFIG = {
  MAX_SUGGESTIONS_HEIGHT: "200px",
  MIN_SUGGESTIONS_COUNT_TO_SHOW: 0,
} as const;

// Error messages
export const ERROR_MESSAGES = {
  NO_LOCATION_DATA: "No location data found for the selected place",
  AUTOCOMPLETE_ERROR: "Error fetching place suggestions",
  PLACE_DETAILS_ERROR: "Error fetching place details",
} as const;

// API response field mappings
export const API_FIELD_MAPPINGS = {
  SUGGESTION_FILTER: (s: any) => s.placePrediction,
  PLACE_ID: (suggestion: any) => suggestion.placePrediction.placeId,
  DESCRIPTION: (suggestion: any) => suggestion.placePrediction.text?.text || "",
  LATITUDE: (data: any) => data.location?.latitude,
  LONGITUDE: (data: any) => data.location?.longitude,
  FORMATTED_ADDRESS: (data: any) =>
    data.formattedAddress ||
    data.displayName?.text ||
    "",
} as const;
